module.exports = __webpack_public_path__ + "img/pexels-photo-3913428.1fe39776.jpeg";